import { useState } from 'react';
import { useTranslation } from "react-i18next";
import TableContainer from '@mui/material/TableContainer';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TextField from '@mui/material/TextField';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';

export const SearchProduct = ({
    openDialog, 
    openDialogSearchProduct, 
    updateProducts,  
    searchResults,
    handleSearch
}) => {
    const { t } = useTranslation();
    const [selecteds, setSelecteds] = useState([])
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const handleSearchQuery = (value, isNameSearch) => {
        if (isNameSearch) {
            setName(value);
            if (value.length >= 5) 
                handleSearch(value, 'SELECT_PRODUCT_SERVICE_LIKE');
        } else {
            setCode(value);
            if (value.length >= 2) 
                handleSearch(value, 'SELECT_BY_SERVICE_CODE_LIKE');
        }
        setSelecteds([]); 
    };
    
    const addSelected = (product) => {
        setSelecteds(product)
    };
    
  return (
    <Dialog open={openDialog} onClose={openDialogSearchProduct} maxWidth="md" fullWidth>
        <DialogTitle>
            {t('crm.products.addProduct')}
            <IconButton
                aria-label="close"
                onClick={openDialogSearchProduct}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextField
                        placeholder={t('crm.products.searhByName')}
                        value={name}
                        onChange={(event) => handleSearchQuery(event.target.value, true)}
                        fullWidth
                        margin="dense"
                        sx={{ mr: 2 }}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField
                        placeholder={t('crm.products.searchByCode')}
                        value={code}
                        onChange={(event) => handleSearchQuery(event.target.value, false)}
                        fullWidth
                        margin="dense"
                        sx={{ mr: 2 }}
                    />
                </Grid>
            </Grid>
            <TableContainer component={Paper} sx={{ mt: 2, maxHeight: 400 }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('crm.products.code')}</TableCell>
                            <TableCell>{t('crm.products.name')}</TableCell>
                            <TableCell>{t('crm.products.description')}</TableCell>
                            <TableCell>{t('crm.products.unitValue')}</TableCell>
                            <TableCell>{t('crm.products.unitOfMeasurement')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {searchResults.map((product, index) => (
                            <TableRow
                                key={index}
                                onClick={() => {
                                    updateProducts(product.code_sku, [product]); 
                                    addSelected(product);
                                    setName('');
                                    openDialogSearchProduct();
                                }}
                                selected={selecteds.code_sku === product.code_sku}
                                sx={{ cursor: 'pointer' }}
                            >
                                <TableCell>{product.code_sku}</TableCell>
                                <TableCell>{product.name}</TableCell>
                                <TableCell>{product.description}</TableCell>
                                <TableCell>{product.price}</TableCell>
                                <TableCell>{product.unit_code}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </DialogContent>
    </Dialog>
  )
}
